import routerApps from "@/tenant/GOOGLE/route/apps"
import routerEasy from "@/router/route/easy"
import routerLogin from "@/router/route/login.js"
import routerExternal from "@/tenant/GOOGLE/route/external.js"
import routerTest from "@/router/route/test.js"

const routes = [
    ...routerApps,
    ...routerEasy,
    ...routerLogin,
    ...routerExternal,
    ...routerTest,
]

export { routes }
